// @flow

import React from 'react';

import { Modal } from '@zapier/common-components';

import WithTeamMembers from './WithZapTransferTeamMembers';
import ZapTransfer from './ZapTransfer';

import type { ZapTransferType } from 'app/dashboard/types';

type Props = {
  onTransferZap: ZapTransferType => void,
  onCancel: () => void,
  zap: Object,
};

const ZapTransferContainer = (props: Props) => {
  if (!props.zap.id || !props.zap.account_id) return null;

  return (
    <WithTeamMembers accountId={props.zap.account_id}>
      {teamMembers => (
        <Modal closeOnOutsideClick={true} onClose={props.onCancel}>
          <ZapTransfer
            onCancel={props.onCancel}
            onSearchMembers={teamMembers.onSearchMembers}
            onTransferZap={props.onTransferZap}
            zap={props.zap}
          />
        </Modal>
      )}
    </WithTeamMembers>
  );
};

export default ZapTransferContainer;
